<nb-card>
    <ng-container *ngIf="viewType">
        <div [ngSwitch]="viewType">
            <span *ngSwitchCase="'ViewBlogArticle'">
                <ubs-view-blog-container [selectedValue]="selectedValue"></ubs-view-blog-container>
            </span>
            <span *ngSwitchCase="'list'">
                <!-- <ubs-view-blog-container [selectedValue]="selectedValue"></ubs-view-blog-container> -->
                <ubs-ofbiz-find-results [result]="result" [listForm]="listForm" [state]="state"></ubs-ofbiz-find-results>
            </span>

            <span *ngSwitchCase="'Product'">
            
            </span>
        </div>
    </ng-container>
    
    <ng-container *ngIf="views">
        <nb-card-body>
            <nb-tabset>
                <nb-tab *ngFor="let view of views" tabTitle="{{view?.title}}">
                    <div [ngSwitch]="view?.type">
                        <span *ngSwitchCase="'single'">
                            <ubs-view-single-container [value]="selectedValue" [componentConfig]="componentConfig" [options]="view"></ubs-view-single-container>    
                        </span>
                        <span *ngSwitchCase="'list'">
                            <ubs-view-list-container [value]="selectedValue" [componentConfig]="componentConfig" [options]="view"></ubs-view-list-container>
                        </span>
                        <span *ngSwitchCase="'combo'">
                            <ubs-view-combo-container [value]="selectedValue" [componentConfig]="componentConfig" [options]="view"></ubs-view-combo-container>
                        </span>
                    </div>
                </nb-tab>
            </nb-tabset>
        </nb-card-body>
    </ng-container>
</nb-card>


